import { Alert } from "@dehub/theme";
import { InfoIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

/** Calm info note (theme Alert) replacing the red alert; no close button. */
export function BranchNotice() {
  const { t } = useTranslation("sector");

  return (
    <Alert color="gray" icon={<InfoIcon size={18} aria-hidden="true" />} role="note">
      {t("notice")}
    </Alert>
  );
}
